import { SubAccount, SubAccountsListsApi, SubAccountsResponse, SubAccountsResponseApi } from './VoPayApi.types';

function normalizeSubAccount(account: SubAccountsListsApi): SubAccount {
  const { ParentAccounts, SubAccounts, ...rest } = account;

  return {
    ...rest,
    ParentAccounts: Object.values(ParentAccounts || {}),
    SubAccounts: Object.values(SubAccounts || {}).map(normalizeSubAccount),
  };
}

export function normalizeSubAccounts(response: SubAccountsResponseApi): SubAccountsResponse {
  return {
    ...response,
    Subaccounts: Object.values(response.Subaccounts || {}).map(normalizeSubAccount),
  };
}
